import type { GridRow } from '~/pages/inventory-import/lib/rows';
import {
  productById,
  productLabel,
} from '~/pages/inventory-import/lib/catalog';
import { locationLabel } from '~/pages/inventory-import/lib/locationCatalog';

/** Human-readable length for a row (the resolved product length's display value, else the raw). */
export function lengthDisplay(row: GridRow): string {
  const product = productById(String(row.product ?? ''));
  const inches = String(row.lengthInches ?? '');
  const match = product?.lengths.find(
    (l) => String(l.actualLengthInches) === inches
  );
  return match?.displayValue ?? String(row.length ?? '');
}

export function productDisplay(row: GridRow): string {
  return (
    productLabel(String(row.product ?? '')) || String(row.descriptor ?? '')
  );
}

export function locationDisplay(row: GridRow): string {
  const code = String(row.location ?? '');
  return code ? locationLabel(code) : String(row.locationCode ?? '');
}
